import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageNav } from './PageNav';
import { getPageByPath } from '../../data/pages';
export function PageLayout() {
  const location = useLocation();
  const page = getPageByPath(location.pathname);
  return <div className="flex min-h-full w-full flex-col bg-white font-body text-charcoal" data-id="element-52" data-mp="1nsgbyoflw3oa">
      <Header data-id="element-53" data-mp="102m0obaxqn65" />
      <main className="flex-1 pt-[73px]" data-id="element-54" data-mp="102c8qi6by5xt">
        <Outlet data-id="element-55" data-mp="v3iugnj7yawl" />
      </main>
      <PageNav currentOrder={page.order} data-id="element-56" data-mp="v4aq1yctg8mv" />
      <Footer data-id="element-57" data-mp="v5c3g9hb177r" />
    </div>;
}